import { Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"

export function CommunicationPreferencesTitle() {
    const t = useTranslations("CommunicationPreferencesTitle")

    return <Typography textStyle="h5">{t("title")}</Typography>
}

CommunicationPreferencesTitle.messages = ["CommunicationPreferencesTitle"] as const
